
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Kondhwatomumbaicab() {



    const cardData =
    {
        keyword: ' Kondhwa to Mumbai Cab',
        heading: 'Prince Cabs: Kondhwa to Mumbai Cab',
        headingDescription: 'Prince Cabs provides dependable Kondhwa to Mumbai Cab services, perfect for airport transfers, business trips, family travel, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride from Kondhwa to Mumbai via the expressway. With professional chauffeurs, on-time pickups, and flexible booking options, we make your travel smooth and hassle-free. Experience comfort, affordability, and trusted service with Prince Cabs’ reliable cab service from Kondhwa to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. At sunset, the arch glows beautifully against the skyline. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Locals and tourists flock here for evening walks, sea breezes, and stunning sunsets. At night, its streetlights resemble a sparkling necklace. During monsoon, waves dramatically crash against the promenade. It reflects the modern, vibrant spirit of Mumbai. Marine Drive is the heart of the city’s leisure life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. Its Gothic Revival architecture features domes, spires, stained glass windows, and intricate carvings. The building looks spectacular when illuminated at night. It is both a functional transport hub and a heritage monument. Tourists admire its grandeur while witnessing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating to the 5th–6th centuries. The highlight is the magnificent Trimurti sculpture of Lord Shiva. The caves reflect India’s ancient artistry and spiritual traditions. Accessible by ferry from Gateway of India, the island offers peace away from the city. Lush greenery surrounds the caves, enhancing their charm. It is a must-visit for history and culture lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, popular for street food and leisure walks. Vendors serve local delights like pav bhaji, bhel puri, and ice gola. Families gather in the evenings to enjoy the sea breeze and sunset. Bollywood celebrities residing nearby make it a star-spotting zone. The beach is lively with children playing and locals exercising. Juhu Beach is Mumbai’s vibrant coastal escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines, dedicated to Lord Ganesha. Built in 1801, it attracts devotees, celebrities, and politicians daily. The golden dome and beautifully carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. Devotees believe wishes made here are fulfilled. Siddhivinayak Temple is the spiritual core of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and an engineering marvel. It connects South Mumbai with the western suburbs, reducing travel time significantly. The bridge offers stunning views of the Arabian Sea and skyline. At night, its illuminated structure looks spectacular. Driving across the Sea Link is a thrilling experience. It is a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is a blend of spirituality and architecture. The dargah is connected by a causeway accessible at low tide. Devotees from all religions visit to seek blessings. Its sea-facing setting creates a serene atmosphere. Haji Ali is Mumbai’s iconic spiritual landmark."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market and shopping paradise. Visitors shop for clothes, handicrafts, jewelry, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to the charm. The area is always lively with both locals and tourists. Bargaining with street vendors is part of the fun. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. Families and couples enjoy snacks like pav bhaji, kulfi, and bhel here. The beach is vibrant during evenings and festivals. It offers views of Marine Drive’s arc and the Arabian Sea. Children love playing in the sand and waves. Girgaon Chowpatty is Mumbai’s blend of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread over 500 acres. It has studios, artificial sets, and shooting zones for films and TV shows. Guided tours take visitors behind the scenes of movie production. Cinema lovers enjoy spotting live shoots. It is one of the largest film complexes in the world. Film City showcases Mumbai’s entertainment identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist stupas and rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such nature in a metro. This park blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and skyscrapers. It is popular among birdwatchers, with species like herons and kingfishers often spotted. Joggers and photographers enjoy its promenade. During monsoon, the lake looks especially scenic with misty surroundings. It is a peaceful retreat within the bustling city. Powai Lake is Mumbai’s hidden natural gem."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation sessions and admire the grand design. Its seaside setting enhances tranquility. The pagoda symbolizes peace, spirituality, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. Sky shows inside its dome theatre explain stars, galaxies, and cosmic wonders. The adjoining Science Centre offers interactive exhibits on innovation and technology. Families and students find it educational yet entertaining. Special events are held during eclipses and celestial events. It is Mumbai’s hub of science and curiosity."
  }
],

"services": [
  {
    "name": "Kondhwa to Mumbai Cab Booking",
    "description": "Book a cab from Kondhwa to Mumbai for a convenient and stress-free intercity journey. Our service ensures on-time pickups, professional drivers, and a range of vehicle options including sedans, SUVs, and MPVs. Ideal for business trips, personal travel, and airport transfers."
  },
  {
    "name": "Kondhwa to Mumbai Innova Crysta",
    "description": "Travel in comfort from Kondhwa to Mumbai with our Innova Crysta cab. This 6/7-seater is perfect for families and groups, offering premium interiors, ample space for luggage, and a smooth ride. Great choice for long-distance road trips with added comfort."
  },
  {
    "name": "Kondhwa to Mumbai Swift Dzire",
    "description": "Choose a Swift Dzire taxi from Kondhwa to Mumbai for an affordable and reliable journey. Ideal for individuals and small families, Dzire offers excellent fuel efficiency, AC comfort, and a hassle-free experience throughout your trip."
  },
  {
    "name": "Kondhwa to Mumbai One Way Taxi",
    "description": "Book a one-way taxi from Kondhwa to Mumbai at competitive rates. Our one-way service provides clean cars, experienced drivers, and no return fare charges—making it ideal for single-side trips, airport drops, or short-term visits."
  },
  {
    "name": "Kondhwa to Mumbai Round Trip Cab",
    "description": "Plan your round trip from Kondhwa to Mumbai with our reliable cab service. Enjoy the convenience of return travel, waiting time flexibility, and professional service in well-maintained vehicles suited for every type of traveler."
  },
  {
    "name": "Kondhwa to Mumbai Drop Taxi",
    "description": "Need a drop to Mumbai from Kondhwa? Our drop taxi service ensures timely pickup and drop without return fare. Get clean, air-conditioned vehicles, experienced drivers, and a comfortable ride for your one-way travel needs."
  },
  {
    "name": "Kondhwa to Mumbai Sedan Cab",
    "description": "Hire a sedan cab from Kondhwa to Mumbai for a comfortable and budget-friendly travel solution. Vehicles like Dzire and Etios are ideal for small families or professionals looking for a smooth ride with minimal luggage."
  },
  {
    "name": "Kondhwa to Mumbai Ertiga Cab",
    "description": "Travel with ease in our 6/7-seater Ertiga cab from Kondhwa to Mumbai. Suitable for families and groups, the Ertiga offers ample legroom and luggage space, making it a practical and economical choice for intercity travel."
  },
  {
    "name": "Kondhwa to Mumbai Tempo Traveller",
    "description": "Book a Tempo Traveller from Kondhwa to Mumbai for large groups or corporate travel. With 9 to 13 seats, AC, and plenty of luggage space, this option is ideal for weddings, tours, and events requiring group transportation."
  },
  {
    "name": "Kondhwa to Mumbai SUV Rental",
    "description": "Hire an SUV from Kondhwa to Mumbai for a powerful and comfortable drive. Our SUV rentals, including models like Innova and Xylo, are perfect for rugged travel, larger groups, or those looking for extra space and premium comfort."
  },
  {
    "name": "Affordable Taxi from Kondhwa to Mumbai",
    "description": "Looking for a budget cab from Kondhwa to Mumbai? Our affordable taxi service offers clean cars, trained drivers, and competitive pricing with no hidden charges—making it the smart choice for value-focused travelers."
  },
  {
    "name": "Kondhwa to Mumbai Night Cab Service",
    "description": "Travel at night from Kondhwa to Mumbai safely with our 24/7 night cab service. Perfect for early morning flights or late-night journeys, we ensure reliable pickups, well-lit vehicles, and alert drivers trained for night travel."
  },
  {
    "name": "Kondhwa to Mumbai Etios Taxi",
    "description": "Book a Toyota Etios cab from Kondhwa to Mumbai for a smooth and stylish ride. The Etios is spacious, fuel-efficient, and ideal for both short and long-distance travel with a small group or solo."
  },
  {
    "name": "Fast Cab from Kondhwa to Mumbai",
    "description": "Get a fast cab from Kondhwa to Mumbai with quick response times and minimal wait. Our express booking option ensures immediate dispatch, ideal for last-minute travel plans or urgent appointments."
  },
  {
    "name": "Kondhwa to Mumbai Luxury Cab",
    "description": "Travel in style with our luxury cab service from Kondhwa to Mumbai. Choose from premium vehicles with plush interiors, professional chauffeurs, and top-tier comfort—perfect for business executives or special occasions."
  }
],
"tableData": [
  ["Kondhwa to Mumbai Cab Booking", "Kondhwa to Mumbai Innova Crysta"],
  ["Kondhwa to Mumbai Swift Dzire", "Kondhwa to Mumbai One Way Taxi"],
  ["Kondhwa to Mumbai Round Trip Cab", "Kondhwa to Mumbai Drop Taxi"],
  ["Kondhwa to Mumbai Sedan Cab", "Kondhwa to Mumbai Ertiga Cab"],
  ["Kondhwa to Mumbai Tempo Traveller", "Kondhwa to Mumbai SUV Rental"],
  ["Affordable Taxi from Kondhwa to Mumbai", "Kondhwa to Mumbai Night Cab Service"],
  ["Kondhwa to Mumbai Etios Taxi", "Fast Cab from Kondhwa to Mumbai"],
  ["Kondhwa to Mumbai Luxury Cab"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Kondhwa to Mumbai Cab Service",
    "WhyChoosedescription": "Prince Cabs offers dependable and comfortable cab services from Kondhwa, Pune to Mumbai, ensuring you enjoy a stress-free and timely journey. Whether you are traveling for business, leisure, or family visits, our service is designed to provide a smooth ride from the heart of Kondhwa to various destinations across Mumbai, including the airport and city centers."
  },
  {
    "WhyChooseheading": "Wide Selection of Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet includes a variety of well-maintained vehicles such as sedans and SUVs like Swift Dzire, Honda Amaze, and Innova Crysta, catering to different group sizes and luggage requirements. All vehicles are equipped with air conditioning and comfortable seating to ensure a pleasant travel experience during the long journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing for cab services from Kondhwa to Mumbai, with no hidden charges. Our fares cover fuel, tolls, driver allowances, and taxes, allowing you to plan your trip without any surprises. Flexible payment options including UPI, cards, and cash are accepted for your convenience."
  },
  {
    "WhyChooseheading": "Flexible and Easy Booking Options",
    "WhyChoosedescription": "Booking your Kondhwa to Mumbai cab is simple and flexible with Prince Cabs. You can book via phone, WhatsApp, or online platforms with instant confirmation. Our cancellation and rescheduling policies are customer-friendly, letting you adjust your travel plans as needed without hassle."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our professional drivers are experienced and knowledgeable about the best routes from Kondhwa to Mumbai, ensuring a safe, timely, and efficient journey. They prioritize passenger comfort, assist with luggage, and maintain courteous communication throughout your ride."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Safe Vehicles",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are thoroughly cleaned and sanitized before every trip, especially important during these times. Equipped with safety features such as seat belts and airbags, our cabs provide a secure environment for all passengers."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Travel",
    "WhyChoosedescription": "Our dedicated customer care team is available 24/7 to assist you with bookings, itinerary changes, and any queries related to your Kondhwa to Mumbai cab service. We aim to make your travel experience smooth, convenient, and worry-free from start to finish."
  }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab service from Kondhwa to Mumbai?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services from Kondhwa, Pune to Mumbai for one-way and round trips.',
    },
    {
        question: 'What types of vehicles are available for Kondhwa to Mumbai trips?',
        answer: 'We provide a range of vehicles including Swift Dzire, Innova, Ertiga, and Tempo Traveller to meet your travel requirements.',
    },
    {
        question: 'How long does the journey from Kondhwa to Mumbai take by cab?',
        answer: 'The travel time usually ranges between 3.5 to 4.5 hours depending on traffic conditions.',
    },
    {
        question: 'Can I book a one-way cab from Kondhwa to Mumbai?',
        answer: 'Yes, Prince Cabs offers flexible one-way cab bookings without any mandatory return trip commitments.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for Kondhwa to Mumbai trips?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced for your safety and comfort.',
    },
    {
        question: 'What are the approximate fares for Kondhwa to Mumbai cab service?',
        answer: 'Fares vary based on vehicle type and trip details. Please contact Prince Cabs for a personalized quote.',
    },
    {
        question: 'How do I book a cab from Kondhwa to Mumbai?',
        answer: 'You can book easily via our website or by calling our customer support team for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Sachin More",
        position: "Business Traveler",
        text: "I regularly use Prince Cabs from Kondhwa to Mumbai. The service is punctual, and the cars are clean and comfortable.",
        image: "/img/testimonial/testimonial-thumb-kondhwa-mumbai-1.png",
    },
    {
        name: "Ms. Anjali Patil",
        position: "Family Traveler",
        text: "Prince Cabs provided a hassle-free and comfortable ride from Kondhwa to Mumbai. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-kondhwa-mumbai-2.png",
    },
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Kondhwa to Mumbai Cab",
  "description": "Book reliable and affordable cabs from Kondhwa to Mumbai including Innova Crysta, Dzire, Ertiga, Sedan, SUV, and Tempo Traveller. One-way, round trip, night travel, and luxury cab services available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Kondhwa",
      "addressRegion": "Pune, Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Kondhwa to Mumbai Cab Booking",
    "Kondhwa to Mumbai Innova Crysta",
    "Kondhwa to Mumbai Swift Dzire",
    "Kondhwa to Mumbai One Way Taxi",
    "Kondhwa to Mumbai Round Trip Cab",
    "Kondhwa to Mumbai Drop Taxi",
    "Kondhwa to Mumbai Sedan Cab",
    "Kondhwa to Mumbai Ertiga Cab",
    "Kondhwa to Mumbai Tempo Traveller",
    "Kondhwa to Mumbai SUV Rental",
    "Affordable Taxi from Kondhwa to Mumbai",
    "Kondhwa to Mumbai Night Cab Service",
    "Kondhwa to Mumbai Etios Taxi",
    "Fast Cab from Kondhwa to Mumbai",
    "Kondhwa to Mumbai Luxury Cab"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Kondhwa to Mumbai Cab | Book Innova, Dzire, SUV, Tempo Traveller</title>
  <meta
    name="description"
    content="Affordable cab service from Kondhwa to Mumbai. Book Innova Crysta, Dzire, Etios, SUV, Sedan or Tempo Traveller for one-way, round trip or night travel. Fast and reliable service."
  />
  <meta
    name="keywords"
    content="Kondhwa to Mumbai Cab Booking, Kondhwa to Mumbai Innova Crysta, Kondhwa to Mumbai Swift Dzire, Kondhwa to Mumbai One Way Taxi, Kondhwa to Mumbai Round Trip Cab, Kondhwa to Mumbai Drop Taxi, Kondhwa to Mumbai Sedan Cab, Kondhwa to Mumbai Ertiga Cab, Kondhwa to Mumbai Tempo Traveller, Kondhwa to Mumbai SUV Rental, Affordable Taxi from Kondhwa to Mumbai, Kondhwa to Mumbai Night Cab Service, Kondhwa to Mumbai Etios Taxi, Fast Cab from Kondhwa to Mumbai, Kondhwa to Mumbai Luxury Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kondhwatomumbaicab ;